<div>
    <div class="o-modal__head o-modal__head--orange">
        <button class="o-modal__close close-modal" style="background-color: transparent; border: 0;" [mat-dialog-close]></button>
        <label class="o-title o-title--white o-title--medium">{{'NewCardPhotoPortal.title' | translate}}</label>
    </div>
    <div class="o-modal__body">

        <div class="o-modal__img"><img [src]="image"></div>
    </div>
    <div class="o-modal__footer o-modal__footer--center">
        <button class="btn btn--default" [mat-dialog-close]>{{'NewCardPhotoPortal.btnCancel' | translate}}</button>
        <button class="btn btn--primary" (click)="send()">{{'NewCardPhotoPortal.btnAccept' | translate}}</button>
    </div>
</div>